import React from 'react';
import { Container, Graphics } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import BalanceWrapper from '../../common/balanceWrapper';
import LastWinWrapper from '../../common/lastWinWrapper';
import GameSettingsWrapper from '../../common/gameSettingsWrapper';
import ClassicBettingPartWrapper from '../../common/classicBettingPartWrapper';
import { menuSectionStore } from '../../../store/menuSectionStore';
import { userInfoStore } from '../../../store/userInfoStore';

const MobileFooterContainer = observer(() => {
  const { isShowMenuPopup } = menuSectionStore;
  const { isReplay } = userInfoStore;

  return (
    <Container visible={!isShowMenuPopup} y={575}>
      <LastWinWrapper />
      <ClassicBettingPartWrapper />
      <Graphics
        draw={(g) => {
          g.clear();
          g.beginFill(0x030303);
          g.alpha = 0;
          g.drawRect(0, 0, 530, 350);
          g.interactive = isReplay;
          g.visible = isReplay;
        }}
      />
      <Container x={0} y={339}>
        <GameSettingsWrapper />
        <BalanceWrapper />
      </Container>
    </Container>
  );
});

export default MobileFooterContainer;
